import CircularProgress from "@mui/material/CircularProgress";
import type { CircularProgressProps } from "@mui/material/CircularProgress";
import DownloadIcon from "@mui/icons-material/Download";

/**
 * The absolutely-centered overlay spinner shown inside a `relative` button while
 * its action is in flight. Replaces the CircularProgress + sx block that was
 * copy-pasted across ~11 modals / action bars (each carrying a no-op `color: ""`).
 *
 * `download` overlays a download glyph inside the spinner ring — the affordance the
 * former GreyButtonElement showed on its download buttons while a file generated.
 */
export interface ButtonSpinnerProps {
  /** Diameter in px; also drives the centering offset math. */
  size?: number;
  /** Spinner colour; `"inherit"` picks up the button's text colour. */
  color?: CircularProgressProps["color"];
  /** Overlay a download glyph inside the spinner (for download/generate buttons). */
  download?: boolean;
}

export const ButtonSpinner = ({ size = 24, color, download = false }: ButtonSpinnerProps) => (
  <>
    <CircularProgress
      size={size}
      color={color}
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: `${-size / 2}px`,
        marginLeft: `${-size / 2}px`,
      }}
    />
    {download && (
      <DownloadIcon
        fontSize="small"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          marginTop: `${-10}px`,
          marginLeft: `${-10}px`,
        }}
      />
    )}
  </>
);
